import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";

import axios from "../../api/axios-allure-docker";
import AllureDockerBar from "../../containers/AllureDockerBar/AllureDockerBar";
import AllureDockerProject from "../../containers/AllureDockerProject/AllureDockerProject";
import AllureDockerSnackBar from "../../components/AllureDockerSnackBar/AllureDockerSnackBar";
import AllureDockerHomePage from "../../components/AllureDockerHomePage/AllureDockerHomePage"
import { redirect } from "../../utility/navigate"

// Второй <main> отсюда убран: им владеет AllureDockerBar, он же держит отступ
// под drawer. Здесь остаётся только ограничение ширины контента.
const styles = () => ({
  content: {
    maxWidth: 1440,
    margin: "0 auto",
  },
});

const autoHideDurationSuccessAlert = 3000;
const autoHideDurationErrorAlert = 6000;
const autoHideDurationInfoAlert = 3000;
class AllureDockerMainContainer extends Component {
  state = {
    projects: [],
    folders: [],
    // null — «цифр нет» (ещё не доехали или запрос упал), массив — реальные
    // данные. Пустой массив как начальное значение подменял отказ правдоподобными
    // нулями: при 500 главная показывала «Projects 0 · Tests 0» при живом дереве.
    statistics: null,
    projectSelected: null,
    isMoving: false,
    apiAlert: {
      severity: "info",
      show: false,
      message: "",
      duration: 0,
    }
  };

  componentDidMount() {
    this.getProjects();
  }

  selectProject = (projectId) => {
    this.setState({ projectSelected: projectId });
  };

  // Статистику тянем отсюда, а не из componentDidMount: getProjects вызывают
  // все мутации (create/delete/move), а компонент при навигации не
  // размонтируется — иначе плитки расходились бы с деревом до F5.
  getProjects = () => {
    this.getStatistics();
    axios
      .get("/projects")
      .then((response) => {
        const projects = response.data.data.projects;
        this.setState({
          projects: response.data.data.projects,
          // '|| []' держит UI живым против старого образа API во время выкатки
          folders: response.data.data.folders || [],
          projectSelected: null,
        });
        if (projects.length !== 0) {
          this.selectProject(Object.keys(projects)[0]);
        }
      })
      .catch((error) => {
        redirect(error);
        this.setAPIAlert("error", error.message, true);
      });
  };

  // Отдельный запрос, а не продолжение .then у getProjects: дерево должно
  // рисоваться сразу, а цифры доезжать следом и не блокировать навигацию.
  getStatistics = () => {
    axios
      .get("/projects/statistics")
      .then((response) => {
        this.setState({ statistics: response.data.data.statistics || [] });
      })
      .catch(() => {
        // Статистика — украшение главной, а не условие работы приложения:
        // тревожный тост здесь не нужен, дерево и отчёты работают как
        // работали. Но и подменять отказ нулями нельзя — null означает «цифр
        // нет», и главная показывает прочерки вместо выдуманных значений.
        // Заодно это держит UI живым против старого образа API во время
        // выкатки, где маршрута ещё нет.
        this.setState({ statistics: null });
      });
  };

  // Обновление после мутации — рефетч, а не оптимистичная правка дерева: так
  // делают все существующие диалоги, а ответ /projects крошечный.
  moveProject = (projectId, targetFolderId) => {
    if (this.state.isMoving) {
      return;
    }
    this.setState({ isMoving: true });
    axios
      .post("/projects/move", { id: projectId, target: targetFolderId })
      .then((response) => {
        const newProjectId = response.data.data.id;
        this.setState({ isMoving: false });
        this.getProjects();
        if (this.props.match.params.id === projectId) {
          this.props.history.replace(`/projects/${newProjectId}`);
        }
        this.setAPIAlert("success", `Project moved to ${newProjectId}`, true);
      })
      .catch((error) => {
        this.setState({ isMoving: false });
        redirect(error);
        this.setAPIAlert("error", error.message, true);
      });
  };

  createFolder = (folderId) => {
    return axios.post("/project-folders", { id: folderId }).then((response) => {
      this.getProjects();
      this.setAPIAlert("success", `Folder ${response.data.data.id} created succesfully!`, true);
    });
  };

  deleteFolder = (folderId) => {
    return axios.delete(`/project-folders/${folderId}`).then(() => {
      this.getProjects();
      this.setAPIAlert("success", `Folder ${folderId} removed succesfully!`, true);
    });
  };

  setAPIAlert = (severity, message, show) => {
    const apiAlert = { ...this.state.apiAlert };
    apiAlert.severity = severity;
    apiAlert.show = show;
    apiAlert.message = message;
    if (severity === "success") {
      apiAlert.duration = autoHideDurationSuccessAlert;
    }
    if (severity === "error") {
      apiAlert.duration = autoHideDurationErrorAlert;
    }
    if (severity === "info") {
      apiAlert.duration = autoHideDurationInfoAlert;
    }
    this.setState({ apiAlert: apiAlert });
  };

  resetAPIAlert = () => {
    const apiAlert = { ...this.state.apiAlert };
    apiAlert.show = false;
    apiAlert.message = "";
    apiAlert.duration = 0;
    this.setState({ apiAlert: apiAlert });
  };

  render() {
    const { classes } = this.props;

    let projects = [];
    if (this.state.projects) {
      projects = this.state.projects;
    }

    const allureProject = (
      <AllureDockerProject
        setAPIAlert={this.setAPIAlert}
        getProjects={this.getProjects}
        folders={this.state.folders}
        moveProject={this.moveProject}
      />
    );

    let content = (
      <AllureDockerHomePage
        projects={projects}
        folders={this.state.folders}
        statistics={this.state.statistics}
      />
    );
    if (this.props.match.params.id) {
      content = allureProject;
    }

    const allureDocker = (
      <AllureDockerBar
        projects={projects}
        folders={this.state.folders}
        getProjects={this.getProjects}
        moveProject={this.moveProject}
        createFolder={this.createFolder}
        deleteFolder={this.deleteFolder}
        isMoving={this.state.isMoving}
        darkState={this.props.darkState}
        handleThemeChange={this.props.handleThemeChange}
        selectProject={this.selectProject}
        setAPIAlert={this.setAPIAlert}
        isLogoutNeeded={this.props.isLogoutNeeded}
        isSignInAnOption={this.props.isSignInAnOption}
      >
        <div className={classes.content}>
          <AllureDockerSnackBar
            severity={this.state.apiAlert.severity}
            show={this.state.apiAlert.show}
            message={this.state.apiAlert.message}
            duration={this.state.apiAlert.duration}
            resetAPIAlert={this.resetAPIAlert}
          />
          {content}
        </div>
      </AllureDockerBar>
    );
    return (
      <React.Fragment>
        {allureDocker}
      </React.Fragment>
    );
  }
}

export default withStyles(styles, { withTheme: true })(
  withRouter(AllureDockerMainContainer)
);
